import { render } from "./LeaveListTableHeader.vue?vue&type=template&id=785b30ac&scoped=true"
import script from "./LeaveListTableHeader.vue?vue&type=script&lang=js"
export * from "./LeaveListTableHeader.vue?vue&type=script&lang=js"

import "./LeaveListTableHeader.vue?vue&type=style&index=0&id=785b30ac&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785b30ac"]])

export default __exports__